import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import type { PrivacyPolicySimpleDTO } from '../privacyPolicy.types';

export class PrivacyPolicySimpleModel {
  private readonly _dto: PrivacyPolicySimpleDTO;

  constructor(dto: PrivacyPolicySimpleDTO) {
    this._dto = dto;
  }

  get originDTO(): PrivacyPolicySimpleDTO {
    return this._dto;
  }

  get privacyPolicyId(): string {
    return this._dto.privacyPolicyId;
  }

  get version(): number {
    return this._dto.version;
  }

  get effectiveDate(): Dayjs {
    return dayjs(this._dto.effectiveDate);
  }

  get status(): 'DRAFT' | 'PUBLISHED' {
    return this._dto.status;
  }

  get isLatest(): boolean {
    return this._dto.isLatest;
  }

  get createdDate(): Dayjs {
    return dayjs(this._dto.createdDate);
  }

  get updatedDate(): Dayjs {
    return dayjs(this._dto.updatedDate);
  }

  get formattedEffectiveDate(): string {
    return dayjs(this._dto.effectiveDate).format('YYYY.MM.DD');
  }

  get formattedCreatedDate(): string {
    return dayjs(this._dto.createdDate).format('YYYY.MM.DD');
  }

  get formattedUpdatedDate(): string {
    return dayjs(this._dto.updatedDate).format('YYYY.MM.DD HH:mm');
  }
}
